<script setup lang="ts">
import type { Project } from '../types';
import TmDataEntry from './TmDataEntry/TmDataEntry.vue';

type Props = {
  projects: Project[];
};

defineProps<Props>();
</script>

<template>
  <TmDataEntry :projects="projects" />
</template>
